export const agentAccountConfig = {
  // Note: The key here determines the final API parameter name, cannot be changed arbitrarily
  projectName: {
    labelKey: 'text0fgh',
    component: "el-input",
    attrs: {
      placeholderKey: 'textaqdq'
    },
    options: [],
    style: {},
    event: {}
  },
  number: {
    labelKey: 'textddyc',
    component: "el-input-number",
    attrs: {
      name: ["purchaseMin", "purchaseMax"]
    },
    options: [],
    style: {},
    event: {},
    customContent: true
  },
  creator: {
    labelKey: 'creator',
    component: "el-tree",
    attrs: {},
    options: [],
    style: {},
    event: {},
    customContent: true
  },
  indicatorId: {
    labelKey: 'textcpps',
    component: "el-select",
    attrs: {},
    options: [
      { key: 'Option 1', value: 'Gold Cake', labelKey: 'common.goldCake' },
      { key: 'Option 2', value: 'Double Skin Milk', labelKey: 'common.doubleSkinMilk' },
      { key: 'Option 3', value: 'Oyster Omelette', labelKey: 'common.oysterOmelette' },
      { key: 'Option 4', value: 'Dragon Beard Noodles', labelKey: 'common.dragonBeardNoodles' }
    ],
    style: {},
    event: {}
  },
  beginTime: {
    labelKey: "createTime",
    component: "el-date-picker",
    attrs: {
      rangeSeparator: "to",
      valueFormat: "yyyy-MM-dd",
      name: ["activateTimeFrom", "activateTimeTo"]
    },
    // customPrefix: true,
    customContent: true, // Date picker needs custom configuration, so this must be true
    // id: "start-time",
    type: "daterange",
    event: {},
    child: {}
  },
  dads: {
    labelKey: "createTime",
    component: "el-date-picker",
    attrs: {
      rangeSeparator: "to",
      valueFormat: "yyyy-MM-dd",
      name: ["acdasdTimeFrom", "acdsadaTimeTo"],
      rule: "required"
    },
    // customPrefix: true,
    customContent: true, //Date picker needs custom configuration, so this must be true
    // id: "start-time",
    type: "daterange",
    event: {},
    child: {}
  },
  selsect2: {
    labelKey: 'relatedPathologyIndicator',
    component: "el-select",
    attrs: { multiple: true, placeholderKey: 'text0pig' },
    options: [
      { key: 'Option 1', value: 'Gold Cake', labelKey: 'common.goldCake' },
      { key: 'Option 2', value: 'Double Skin Milk', labelKey: 'common.doubleSkinMilk' },
      { key: 'Option 3', value: 'Oyster Omelette', labelKey: 'common.oysterOmelette' },
      { key: 'Option 4', value: 'Dragon Beard Noodles', labelKey: 'common.dragonBeardNoodles' }
    ],
    style: {},
    event: {}
  },
  selsect3: {
    labelKey: 'relatedPathologyIndicator',
    component: "el-select",
    attrs: {},
    options: [
      { key: 'Option 1', value: 'Gold Cake', labelKey: 'common.goldCake' },
      { key: 'Option 2', value: 'Double Skin Milk', labelKey: 'common.doubleSkinMilk' },
      { key: 'Option 3', value: 'Oyster Omelette', labelKey: 'common.oysterOmelette' },
      { key: 'Option 4', value: 'Dragon Beard Noodles', labelKey: 'common.dragonBeardNoodles' }
    ],
    style: {},
    event: {}
  },
  dadsTime: {
    labelKey: "createTime",
    component: "el-date-picker",
    attrs: {
      rangeSeparator: "to",
      valueFormat: "yyyy-MM-dd",
      name: ["aTimeFrom", "dTimeTo"]
    },
    // customPrefix: true,
    customContent: true, //Date picker needs custom configuration, so this must be true
    // id: "start-time",
    type: "daterange",
    event: {},
    child: {}
  },
  //Below are two special ones!
  accountType: {
    labelKey: 'text434w',
    component: "el-select",
    attrs: {
      placeholderKey: 'textemxd',
      keyAsValue: true //Use key as option value
    },
    options: [],
    style: {},
    event: {}
  },
  payMethod: {
    labelKey: 'text88l6',
    component: "el-select",
    attrs: {
      placeholderKey: 'pleaseSelect',
      keyAsValue: true //Use key as option value
    },
    options: [],
    style: {},
    event: {}
  },
  createBy: {
    labelKey: 'textnoy2',
    component: "el-select",
    attrs: {
      placeholderKey: 'text733z',
      keyAsValue: true //Use key as option value
    },
    options: [],
    style: {},
    event: {}
  },
  creator: {
    labelKey: 'down',
    component: "el-tree",
    attrs: {
      placeholderKey: 'text7rqk',
      treeType: "agent"
    },
    options: [],
    style: {},
    event: {},
    customContent: true
  },
  //Agent itself
  campusIds: {
    labelKey: 'agent2',
    component: "el-tree",
    attrs: {
      placeholderKey: 'text7rqk',
      treeType: "agentSelf"
    },
    options: [],
    style: {},
    event: {},
    customContent: true
  }
};
